import React from 'react';
import PropTypes from 'prop-types';
import { YoutubePlayer } from '../youtubePlayer';
import { VimeoPlayer } from '../vimeoPlayer';

export const videoPlayer = props => {
  const { videoHost, ...otherProps } = props;
  if (videoHost === 'youtube') {
    return <YoutubePlayer {...otherProps} />;
  }
  if (videoHost === 'vimeo') {
    return <VimeoPlayer {...otherProps} />;
  }
  return null;
};

videoPlayer.propTypes = {
  videoHost: PropTypes.string.isRequired,
  autoplay: PropTypes.bool,
};

videoPlayer.defaultProps = {
  autoplay: false,
};
